// File: src/components/landing/NonLoggedInHero.jsx

import React, { useEffect, useRef, useState } from "react";

import { LuArrowUpRight, LuPause, LuPlay } from "react-icons/lu";

import JoinTribeQR from "../../assets/JoinTribeQR.svg";

// Add more image URLs here to rotate through a larger photo collection.

const photoPool = [

  "https://i.pinimg.com/736x/e9/e0/de/e9e0de42b1f2e00f2939330f9cab14ca.jpg",

  "https://i.pinimg.com/736x/2d/f6/62/2df66217b64857074687410eed21bc6b.jpg",

  "https://i.pinimg.com/736x/72/ca/0e/72ca0e44535e2b934242dda9c05459ba.jpg",

  "https://i.pinimg.com/736x/d9/4b/08/d94b083d6086c28be3d9b6520dc25043.jpg",

  "https://i.pinimg.com/1200x/81/2a/74/812a740fd17e7fddbe5cc5c00069e422.jpg",

  // Additional Tribe gathering photos keep the moving cards varied.

  "https://i.pinimg.com/736x/8d/00/01/8d0001e14312a07bcf1080f77a6ae995.jpg",

  "https://i.pinimg.com/736x/a4/03/b5/a403b5aa7ab025f6d06fa42ca8c5cac1.jpg",

  "https://i.pinimg.com/736x/fc/65/86/fc65863ea39d138606fa0d900dd31d3a.jpg",

];

const captionPool = [

  "a little good company",

  "same time next week?",

  "come for the plans, stay for the people",

  "your next favorite memory",

  "a good day to meet someone new",

  "see you at the next one",

  "more moments like this",

  "this could be your kind of evening",

];

const PHOTO_STORAGE_KEY = "tribe-hero-polaroids-v1";

let pagePolaroids = null;

function pickRandom(items) {

  return items[Math.floor(Math.random() * items.length)];

}

function getPagePolaroids() {

  // Cache once per page load, including React Strict Mode and route remounts.

  if (pagePolaroids) return pagePolaroids;

  let previous = [];

  try {

    const saved = JSON.parse(window.sessionStorage.getItem(PHOTO_STORAGE_KEY));

    if (Array.isArray(saved)) previous = saved;

  } catch {

    // The hero still works when browser storage is unavailable.

  }

  const uniquePhotos = [...new Set(photoPool)];

  const slots = [

    { className: "tribePolaroid--left", entrySide: "left" },

    { className: "tribePolaroid--right", entrySide: "right" },

    { className: "tribePolaroid--third", entrySide: "right" },

    { className: "tribePolaroid--fourth", entrySide: "left" },

  ];

  const selectedPhotos = [];

  const selectedCaptions = [];

  pagePolaroids = slots.map(({ className, entrySide }, index) => {

    const photoChoices = uniquePhotos.filter(

      (src) =>

        !selectedPhotos.includes(src) &&

        src !== previous[index]?.src

    );

    const availablePhotos = uniquePhotos.filter(

      (src) => !selectedPhotos.includes(src)

    );

    const src = pickRandom(photoChoices.length ? photoChoices : availablePhotos);

    selectedPhotos.push(src);

    const captionChoices = captionPool.filter(

      (caption) =>

        !selectedCaptions.includes(caption) &&

        caption !== previous[index]?.caption

    );

    const availableCaptions = captionPool.filter(

      (caption) => !selectedCaptions.includes(caption)

    );

    const caption = pickRandom(

      captionChoices.length ? captionChoices : availableCaptions

    );

    selectedCaptions.push(caption);

    return {

      src,

      caption,

      className,

      entrySide,

      angleOffset: Number((Math.random() * 4 - 2).toFixed(2)),

    };

  });

  try {

    window.sessionStorage.setItem(

      PHOTO_STORAGE_KEY,

      JSON.stringify(pagePolaroids)

    );

  } catch {

    // Random selection still works; preventing repeats needs storage.

  }

  return pagePolaroids;

}

const activities = [

  "dinner & karaoke",

  "wine & pizza",

  "yoga & picnics",

  "thrifting & coffee",

  "cocktail crawls",

  "decade nights",

  "bike rides & lunch",

  "museum & matcha",

  "movies in the park",

  "drinks & dancing",

  "stairs & smoothies",

];

function RotatingActivity({ paused, reduceMotion }) {

  const [activeActivity, setActiveActivity] = useState(0);

  useEffect(() => {

    if (paused || reduceMotion) return undefined;

    const timer = window.setInterval(() => {

      if (!document.hidden) {

        setActiveActivity((current) => (current + 1) % activities.length);

      }

    }, 3200);

    return () => window.clearInterval(timer);

  }, [paused, reduceMotion]);

  return (

    <span className="tribeActivitySlot" aria-hidden="true">

      {activities.map((activity, index) => (

        <span

          key={activity}

          className={`tribeActivityWord ${

            activeActivity === index ? "is-active" : ""

          }`}

        >

          {activity}

        </span>

      ))}

    </span>

  );

}

export default function NonLoggedInHero() {

  const [polaroids, setPolaroids] = useState(() => [

    { src: photoPool[0], caption: captionPool[0], className: "tribePolaroid--left", entrySide: "left" },

    { src: photoPool[1], caption: captionPool[1], className: "tribePolaroid--right", entrySide: "right" },

    { src: photoPool[2], caption: captionPool[2], className: "tribePolaroid--third", entrySide: "right" },

    { src: photoPool[3], caption: captionPool[3], className: "tribePolaroid--fourth", entrySide: "left" },

  ]);

  const [paused, setPaused] = useState(false);

  const [cardMotion, setCardMotion] = useState({});

  const pausedRef = useRef(paused);

  pausedRef.current = paused;

  const polaroidsRef = useRef(polaroids);

  polaroidsRef.current = polaroids;

  useEffect(() => {

    setPolaroids(getPagePolaroids());

  }, []);

  const [reduceMotion, setReduceMotion] = useState(true);

  useEffect(() => {

    const query = window.matchMedia("(prefers-reduced-motion: reduce)");

    const syncPreference = () => setReduceMotion(query.matches);

    syncPreference();

    query.addEventListener("change", syncPreference);

    return () => query.removeEventListener("change", syncPreference);

  }, []);

  const [isDesktop, setIsDesktop] = useState(() =>

    typeof window !== "undefined" && window.matchMedia("(min-width: 1001px)").matches

  );

  useEffect(() => {

    const query = window.matchMedia("(min-width: 1001px)");

    const syncWidth = () => setIsDesktop(query.matches);

    syncWidth();

    query.addEventListener("change", syncWidth);

    return () => query.removeEventListener("change", syncWidth);

  }, []);

  const desktopPolaroids = polaroids.map((photo) => {

    const motion = cardMotion[photo.className] || {};

    const rotation = motion.rotation ?? 0;

    return {

      ...photo,

      motionStyle: {

        translate: `${motion.x ?? 0}px calc(${motion.y ?? 0}px + var(--polaroid-interaction-y, 0px))`,

        rotate: `calc(var(--photo-angle, 0deg) ${rotation < 0 ? "-" : "+"} ${Math.abs(rotation)}deg + var(--polaroid-interaction-rotation, 0deg))`,

        scale: `calc(${motion.scale ?? photo.sizeScale ?? 1} * var(--polaroid-interaction-scale, 1))`,

        opacity: motion.opacity ?? 1,

        zIndex: motion.zIndex ?? 2,

        transition: motion.transition ?? "translate 180ms ease, rotate 180ms ease, scale 180ms ease, opacity 180ms ease, box-shadow 180ms ease",

      },

    };

  });

  const randomBetween = (min, max) => min + Math.random() * (max - min);

  const setCardVisual = (className, visual) => {

    setCardMotion((current) => ({ ...current, [className]: visual }));

  };

  const clearCardVisual = (className) => {

    setCardMotion((current) => {

      const next = { ...current };

      delete next[className];

      return next;

    });

  };

  useEffect(() => {

    if (!isDesktop || reduceMotion) return undefined;

    let stopped = false;

    let timer;

    let frameOne;

    let frameTwo;

    const scheduleNext = (delay) => {

      timer = window.setTimeout(() => {

        if (pausedRef.current) {

          scheduleNext(350);

          return;

        }

        runCycle();

      }, delay);

    };

    const runCycle = () => {

      if (stopped) return;

      const cards = polaroidsRef.current;

      if (!cards.length) {

        scheduleNext(100);

        return;

      }

      const card = pickRandom(cards);

      const entersFromLeft = card.entrySide === "left";

      const distanceX = Math.max(window.innerWidth * 0.55, 500);

      // Keep each slot tied to its own edge for every photo cycle.

      const exitX = entersFromLeft ? -distanceX : distanceX;

      const entryX = exitX;

      const exitRotation = Number(randomBetween(-5, 5).toFixed(1));

      const entryRotation = Number(randomBetween(-5, 5).toFixed(1));

      // Choose and start loading the next unique photo before the outgoing
      // card starts moving, so image selection/loading never adds a blank pause.
      const currentCards = polaroidsRef.current;

      const oldCard = currentCards.find((item) => item.className === card.className);

      const remainingCards = currentCards.filter((item) => item.className !== card.className);

      const visiblePhotos = new Set(remainingCards.map((item) => item.src));

      const photoChoices = photoPool.filter(

        (src) => src !== oldCard?.src && !visiblePhotos.has(src)

      );

      const visibleCaptions = new Set(remainingCards.map((item) => item.caption));

      const captionChoices = captionPool.filter((caption) => !visibleCaptions.has(caption));

      const nextCard = {

        src: pickRandom(photoChoices.length ? photoChoices : photoPool.filter((src) => src !== oldCard?.src)),

        caption: pickRandom(captionChoices.length ? captionChoices : captionPool),

        className: card.className,

        entrySide: card.entrySide,

        angleOffset: Number(randomBetween(-10, 10).toFixed(2)),

        sizeScale: Number(randomBetween(0.92, 1.08).toFixed(2)),

      };

      const preloadedImage = new window.Image();

      preloadedImage.src = nextCard.src;

      setCardVisual(card.className, {

        x: exitX,

        y: 0,

        rotation: exitRotation,

        scale: (card.sizeScale ?? 1) * 0.985,

        opacity: 0,

        zIndex: 8,

        transition: "translate 900ms cubic-bezier(.22,.65,.3,1), rotate 900ms cubic-bezier(.22,.65,.3,1), scale 900ms cubic-bezier(.22,.65,.3,1), opacity 700ms ease-in, box-shadow 300ms ease",

      });

      timer = window.setTimeout(() => {

        if (stopped) return;

        setPolaroids((current) =>

          current.map((item) => item.className === card.className ? nextCard : item)

        );

        setCardVisual(card.className, {

          x: entryX,

          y: 0,

          rotation: entryRotation,

          scale: nextCard.sizeScale * 0.985,

          opacity: 0,

          zIndex: 2,

          transition: "none",

        });

        frameOne = window.requestAnimationFrame(() => {

          frameTwo = window.requestAnimationFrame(() => {

            if (stopped) return;

            setCardVisual(card.className, {

              x: 0,

              y: 0,

              rotation: 0,

              scale: nextCard.sizeScale,

              opacity: 1,

              zIndex: 2,

              transition: "translate 1050ms cubic-bezier(.2,.72,.25,1), rotate 1050ms cubic-bezier(.2,.72,.25,1), scale 1050ms cubic-bezier(.2,.72,.25,1), opacity 850ms ease-out, box-shadow 300ms ease",

            });

          });

        });

        timer = window.setTimeout(() => {

          if (stopped) return;

          clearCardVisual(card.className);

          scheduleNext(randomBetween(2200, 3400));

        }, 1080);

      }, 900);

    };

    scheduleNext(1500);

    return () => {

      stopped = true;

      if (timer) window.clearTimeout(timer);

      if (frameOne) window.cancelAnimationFrame(frameOne);

      if (frameTwo) window.cancelAnimationFrame(frameTwo);

    };

  }, [isDesktop, reduceMotion]);

  const scrollToHowItWorks = () => {

    const section =

      document.getElementById("tribe-how-it-works") ||

      document.getElementById("how-it-works");

    section?.scrollIntoView({

      behavior: reduceMotion ? "auto" : "smooth",

      block: "start",

    });

  };

  return (

    <section

      className="tribeCarouselHero tribePolaroidHero"

      data-grain-paused={paused || reduceMotion}

      aria-labelledby="tribe-hero-title"

    >

      <style>

        {`

          .nonloggedLanding {

            position: relative;

          }

          .nonloggedLanding:has(.tribePolaroidHero) > header.desktopLandingNav,

          .nonloggedLanding:has(.tribePolaroidHero) > header.tribeFullLanding__nav {

            position: absolute !important;

            inset: 0 0 auto !important;

            z-index: 10 !important;

            display: flex !important;

            width: 100% !important;

            max-width: none !important;

            margin: 0 !important;

            padding: 20px 32px !important;

            background: transparent !important;

            color: #171717 !important;

          }

          .nonloggedLanding:has(.tribePolaroidHero) > header :is(button, a) {

            color: #171717 !important;

            background: transparent !important;

            border-color: rgba(23, 23, 23, 0.18) !important;

          }

          .nonloggedLanding:has(.tribePolaroidHero) > header

          :is(.desktopLandingLogoBlack, .tribeFullLanding__logo)

          :is(path, circle, rect, polygon, polyline, ellipse) {

            fill: #171717 !important;

          }

          .nonloggedLanding:has(.tribePolaroidHero) > header

          :is(.desktopLandingLogoBlack, .tribeFullLanding__logo)

          [fill="none"] {

            fill: none !important;

          }

          .guest-page:has(.tribePolaroidHero)

          .tribe-auth-nav .tribe-auth-nav__logo {

            filter: none !important;

          }

          .guest-page:has(.tribePolaroidHero)

          .tribe-auth-nav .tribe-auth-nav__brand,

          .guest-page:has(.tribePolaroidHero)

          .tribe-auth-nav .tribe-auth-nav__login {

            color: #171717 !important;

          }

          .guest-page:has(.tribePolaroidHero)

          .tribe-auth-nav .tribe-auth-nav__account,

          .guest-page:has(.tribePolaroidHero)

          .tribe-auth-nav .tribe-auth-nav__signup {

            background: #171717 !important;

            color: #fff !important;

            border: 1px solid #171717 !important;

            backdrop-filter: none;

            -webkit-backdrop-filter: none;

          }

          .guest-page:has(.tribePolaroidHero)

          .tribe-auth-nav .tribe-auth-nav__logo-button:focus-visible {

            outline-color: #171717;

          }

          .tribePolaroidHero,

          .tribePolaroidHero *,

          .tribePolaroidHero *::before,

          .tribePolaroidHero *::after {

            box-sizing: border-box;

          }

          .tribeCarouselHero.tribePolaroidHero {

            position: relative;

            isolation: isolate;

            display: grid;

            align-items: center;

            width: 100%;

            max-width: none;

            min-height: 780px;

            min-height: max(780px, 100svh);

            margin: 0;

            padding: 116px 36px 84px;

            overflow: hidden;

            background: #fff;

            color: #171717;

          }

          /* Self-contained film grain, beneath all hero content. */

          .tribeCarouselHero.tribePolaroidHero::before {

            content: "";

            position: absolute;

            inset: -50%;

            z-index: -1;

            pointer-events: none;

            opacity: 0.05;

            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180' viewBox='0 0 180 180'%3E%3Cfilter id='grain'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.92' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Cpath fill='%23000' filter='url(%23grain)' d='M0 0h180v180H0z'/%3E%3C/svg%3E");

            background-repeat: repeat;

            background-size: 180px 180px;

            animation: tribeHeroGrain 800ms steps(1, end) infinite;

          }

          .tribeCarouselHero.tribePolaroidHero[data-grain-paused="true"]::before {

            animation-play-state: paused;

          }

          @keyframes tribeHeroGrain {

            0%, 100% { transform: translate(0, 0); }

            12.5% { transform: translate(-3%, -4%); }

            25% { transform: translate(4%, 2%); }

            37.5% { transform: translate(-2%, 5%); }

            50% { transform: translate(5%, -3%); }

            62.5% { transform: translate(-4%, 1%); }

            75% { transform: translate(2%, 4%); }

            87.5% { transform: translate(3%, -2%); }

          }

          @media (min-width: 1001px) {

            .tribePolaroidHero .tribePolaroidHero__layout > .tribePolaroid:is(:hover, :not(:hover)) {

              cursor: pointer;

              user-select: none;

              -webkit-user-select: none;

            }

            .tribePolaroidHero .tribePolaroidHero__layout > .tribePolaroid:active {

              box-shadow: 0 5px 12px rgba(35, 30, 20, 0.12), 0 20px 42px rgba(35, 30, 20, 0.17);

            }

            .tribePolaroidHero .tribePolaroidHero__layout > .tribePolaroid img {

              pointer-events: none;

              -webkit-user-drag: none;

            }

          }

          @media (prefers-reduced-motion: reduce) {

            .tribeCarouselHero.tribePolaroidHero::before {

              animation: none;

            }

          }

          .tribePolaroidHero__layout {

            display: grid;

            grid-template-columns:

              minmax(0, 1fr)

              minmax(0, 2.35fr)

              minmax(0, 1fr);

            align-items: center;

            column-gap: clamp(22px, 3vw, 52px);

            width: 100%;

            max-width: 1480px;

            margin: 0 auto;

          }

          .tribePolaroidHero__content {

            position: relative;

            z-index: 2;

            grid-column: 2;

            grid-row: 1;

            width: 100%;

            min-width: 0;

            text-align: center;

          }

          .tribePolaroidHero__title {

            width: 100%;

            margin: 0;

            color: #171717;

            font-style: normal;

            font-weight: 400;

            line-height: 1.1;

            letter-spacing: normal;

            text-transform: none;

          }

          .tribePolaroidHero .tribeActivityIntro {

            display: block;

            margin: 0 0 5px;

            font-family: "Instrument Serif", Georgia, serif;

            font-size: clamp(24px, 2.3vw, 32px);

            font-style: normal;

            font-weight: 400;

            line-height: 1.15;

            letter-spacing: -0.015em;

          }

          .tribePolaroidHero .tribeActivitySlot {

            position: relative;

            display: grid;

            width: 100%;

            margin: 0;

            padding: 3px 0;

            overflow: hidden;

            font-family: "Gildsley", Impact, sans-serif;

            font-size: clamp(32px, 4.1vw, 62.4px);

            font-style: normal;

            font-weight: 400;

            font-synthesis: none;

            line-height: 1.04;

            letter-spacing: -0.02em;

            text-transform: uppercase;

          }

          .tribePolaroidHero .tribeActivityWord {

            display: block;

            grid-area: 1 / 1;

            align-self: center;

            width: 100%;

            max-width: none;

            opacity: 0;

            transform: translateY(65%);

            transition:

              opacity 420ms ease,

              transform 420ms ease;

            text-wrap: balance;

            pointer-events: none;

          }

          .tribePolaroidHero .tribeActivityWord.is-active {

            opacity: 1;

            transform: translateY(0);

          }

          .tribePolaroidHero__srOnly {

            position: absolute !important;

            width: 1px !important;

            height: 1px !important;

            padding: 0 !important;

            margin: -1px !important;

            overflow: hidden !important;

            clip-path: inset(50%) !important;

            white-space: nowrap !important;

            border: 0 !important;

          }

          .tribePolaroidHero__description {

            max-width: 430px;

            margin: 14px auto 0;

            color: #555;

            font-size: 14px;

            line-height: 1.65;

            font-weight: 400;

            text-wrap: balance;

          }

          /* Membership button is mobile only. */

          .tribePolaroidHero__actions {

            display: none;

            grid-template-columns: max-content max-content;

            gap: 9px 10px;

            align-items: center;

            justify-content: center;

            margin-top: 25px;

          }

          .tribePolaroidHero__howButton {

            display: inline-flex;

            align-items: center;

            justify-content: center;

            min-height: 44px;

            padding: 11px 18px;

            border: 1px solid #171717;

            border-radius: 999px;

            background: transparent;

            color: #171717;

            font-family: inherit;

            font-size: 12px;

            font-weight: 700;

            line-height: 1.3;

            cursor: pointer;

          }

          .tribePolaroidHero__actions > .tribePolaroidHero__howButton {

            border: 1px solid #999;

            border-radius: 999px;

            background: transparent;

          }

          .tribePolaroidHero__howDesktop {

            margin: 18px auto 0;

            padding: 11px 18px;

            min-height: 44px;

            border: 1px solid #171717;

            border-radius: 999px;

            font-size: 13px;

          }

          .tribePolaroidHero__howDesktop:hover {

            text-decoration: underline;

            text-underline-offset: 4px;

          }

          .tribePolaroidHero__howButton:focus-visible {

            outline: 2px solid #171717;

            outline-offset: 4px;

          }

          @media (max-width: 440px) {

            .tribePolaroidHero__howDesktop {

              display: none;

            }

          }

          .tribePolaroidHero__membershipNote {

            margin: 0;

            color: #555;

            font-size: 12px;

            font-weight: 400;

            line-height: 1.4;

            letter-spacing: 0.01em;

          }

          .tribePolaroidHero__actionsNote {

            display: none;
            

          }

          @media (max-width: 440px) {

            .tribePolaroidHero__actionsNote {

              display: block;

              grid-column: 1 / -1;

              justify-self: center;

              text-align: center;

              margin: 0;

              margin: 12px 0 0;

            }

          }

          .tribePolaroidHero__join {

            min-height: 46px;

            display: inline-flex;

            align-items: center;

            justify-content: center;

            gap: 11px;

            padding: 12px 22px;

            border: 1px solid #fbe67a;

            border-radius: 999px;

            background: #fbe67a;

            color: #171717;

            font-family: inherit;

            font-size: 13px;

            font-weight: 700;

            line-height: 1.3;

            text-decoration: none;

            cursor: pointer;

            transition:

              background 160ms ease,

              border-color 160ms ease;

          }

          .tribePolaroidHero__join:hover {

            background: #f5dc59;

            border-color: #f5dc59;

          }

          .tribePolaroidHero__qr {

            display: flex;

            flex-direction: column;

            align-items: center;

            width: fit-content;

            margin: 22px auto 0;

            color: #171717;

            text-decoration: none;

          }

          .tribePolaroidHero__qr img {

            display: block;

            width: 131px;

            height: 131px;

            padding: 7px;

            background: #fff;

            object-fit: contain;

          }

        .tribePolaroidHero__qr strong {

  display: block;

  margin-top: 10px;

  color: #171717;

  font-family: inherit;

  font-size: 13px;

  font-weight: 900;

  line-height: 1.3;

  letter-spacing: normal;

  text-transform: none;

  text-align: center;

}

          .tribePolaroidHero__qr span {

            margin-top: 3px;

            color: #777;

            font-size: 8.8px;

            line-height: 1.4;

          }

          .tribePolaroidHero__qr .tribePolaroidHero__membershipNote {

            margin-top: 6px;

            color: #777;

            font-size: 11px;

            line-height: 1.4;

          }

          .tribePolaroid {

            position: relative;

            grid-row: 1;

            width: 100%;

            max-width: 290px;

            margin: 0;

            padding: 11px 11px 0;

            background: #fff;

            border: 1px solid #eae8e3;

            border-radius: 2px;

            box-shadow:

              0 2px 4px rgba(35, 30, 20, 0.06),

              0 14px 32px rgba(35, 30, 20, 0.1);

          }

          .tribePolaroid--left {

            grid-column: 1;

            justify-self: center;

            transform: translateY(-32px) rotate(-7deg);

          }

          .tribePolaroid--right {

            grid-column: 3;

            justify-self: center;

            transform: translateY(48px) rotate(6deg);

          }

          .tribePolaroid__image {

            display: block;

            width: 100%;

            aspect-ratio: 4 / 5;

            object-fit: cover;

            object-position: center;

            background: #eeeae3;

          }

          .tribePolaroid__caption {

            display: flex;

            align-items: center;

            justify-content: center;

            min-height: 60px;

            margin: 0;

            padding: 10px 2px 12px;

            color: #343c54;

            font-family: "Ugly Handwriting", cursive;

            font-size: clamp(17px, 1.5vw, 22px);

            font-weight: 500;

            line-height: 1.2;

            text-align: center;

          }

          .tribePolaroidHero__pause {

            position: absolute;

            right: 24px;

            bottom: 20px;

            display: inline-flex;

            align-items: center;

            justify-content: center;

            width: 36px;

            height: 36px;

            padding: 0;

            border: 1px solid #e8e8e8;

            border-radius: 50%;

            background: #fff;

            color: #777;

            cursor: pointer;

          }

          .tribePolaroidHero :is(a, button):focus-visible {

            outline: 2px solid #171717;

            outline-offset: 5px;

          }

          /* Keep the desktop composition inset and centered. */

          @media (min-width: 1001px) {

            .tribePolaroidHero__layout {

              width: calc(100% - 64px);

              max-width: 1280px;

              column-gap: clamp(28px, 3vw, 44px);

            }

            .tribePolaroid--left {

              max-width: 260px;

              justify-self: end;

              transform: translateY(-28px) rotate(-5deg);

            }

            .tribePolaroid--right {

              width: 90%;

              max-width: 234px;

              justify-self: start;

              transform: translateY(44px) rotate(4deg);

            }

          }

          /* Keep the desktop composition in one row all the way to 440px.

             Below 792px, the outer photo edges crop at the viewport edges;

             the center column remains fully visible and readable. */

          @media (min-width: 441px) and (max-width: 1000px) {

            .tribePolaroidHero__layout {

              position: relative;

              left: 50%;

              transform: translateX(-50%);

              width: max(720px, 100%);

              max-width: none;

              margin: 0;

              grid-template-columns:

                minmax(0, 1fr)

                minmax(360px, 2.2fr)

                minmax(0, 1fr);

              column-gap: 28px;

              align-items: center;

            }

            .tribePolaroidHero__content {

              grid-column: 2;

              grid-row: 1;

            }

            .tribePolaroid {

              grid-row: 1;

              max-width: 220px;

            }

            .tribePolaroid--left {

              grid-column: 1;

              justify-self: end;

              transform: translateY(-28px) rotate(-5deg);

            }

            .tribePolaroid--right {

              grid-column: 3;

              width: 90%;

              justify-self: start;

              transform: translateY(44px) rotate(4deg);

            }

            .tribePolaroidHero .tribeActivitySlot {

              font-size: clamp(30px, 4.1vw, 41px);

            }

            .tribePolaroid__caption {

              font-size: clamp(14px, 1.7vw, 17px);

              overflow-wrap: anywhere;

            }

          }

          .tribePolaroidHero__mobileMarquee {

            display: none;

          }

          @media (max-width: 440px) {

            .nonloggedLanding:has(.tribePolaroidHero) > header.desktopLandingNav,

            .nonloggedLanding:has(.tribePolaroidHero) > header.tribeFullLanding__nav {

              display: none !important;

            }

            .tribeCarouselHero.tribePolaroidHero,

            .guest-page .tribeCarouselHero.tribePolaroidHero {

              display: block;

              min-height: 90svh;

              padding: 120px 20px 90px;

            }

            .tribePolaroidHero__layout {

              grid-template-columns: repeat(2, minmax(0, 1fr));

              align-items: start;

              column-gap: 0;

              row-gap: 20px;

              max-width: 460px;

            }

            .tribePolaroidHero__content {

              grid-column: 1 / -1;

              grid-row: 1;

            }

            .tribePolaroidHero .tribeActivityIntro {

              margin-bottom: 5px;

              font-size: clamp(25px, 6.8vw, 32px);

            }

            .tribePolaroidHero .tribeActivitySlot {

              width: calc(100% + 24px);

              margin-inline: -12px;

              padding: 3px 0;

              font-size: clamp(36px, 10vw, 56px);

              line-height: 1.04;

            }

            .tribePolaroidHero__description {

              max-width: 290px;

              margin-top: 12px;

              font-size: 13px;

              line-height: 1.6;

            }

            .tribePolaroidHero__actions {

              display: grid;

              margin-top: 24px;

            }

            .tribePolaroidHero__join {

              min-height: 44px;

              padding: 11px 18px;

              font-size: 12px;

            }

            .tribePolaroidHero__qr {

              display: none;

            }

            .tribePolaroidHero__mobileMarquee {

              display: block;

              grid-column: 1 / -1;

              grid-row: 2;

              width: calc(100% + 40px);

              margin: 0px -20px 0;

              padding: 14px 0 18px;

              overflow-x: clip;

              overflow-y: visible;

            }

            .tribePolaroidHero__mobileTrack {

              display: flex;

              width: max-content;

              gap: 0;

              animation: tribePolaroidTicker 34s linear infinite;

              will-change: transform;

            }

            .tribePolaroidHero[data-grain-paused="true"] .tribePolaroidHero__mobileTrack {

              animation-play-state: paused;

            }

            @keyframes tribePolaroidTicker {

              from { transform: translateX(0); }

              to { transform: translateX(-50%); }

            }

            .tribePolaroidHero__layout > .tribePolaroid {

              display: none;

            }

            .tribePolaroidHero__mobileCard {

              display: block;

              position: relative;

              flex: 0 0 min(190px, calc((100vw - 40px) / 2));

              width: min(190px, calc((100vw - 40px) / 2));

              max-width: none;

              margin-left: -24px;

              padding: 7px 7px 0;

              transform: none !important;

              --photo-angle: var(--mobile-angle, 0deg);

              box-shadow:

                0 2px 3px rgba(35, 30, 20, 0.05),

                0 8px 18px rgba(35, 30, 20, 0.09);

            }

            .tribePolaroidHero__mobileSet {

              display: flex;

              flex: none;

              gap: 0;

              padding: 0 14px;

            }

            .tribePolaroidHero__mobileCard:first-child {

              margin-left: 0;

            }

            .tribePolaroidHero__mobileCard:last-child {

              margin-right: -52px;

            }

            .tribePolaroidHero .tribePolaroidHero__mobileCard:nth-child(3n + 1) {

              translate: 0 7px;

            }

            .tribePolaroidHero .tribePolaroidHero__mobileCard:nth-child(3n + 2) {

              translate: 0 -5px;

            }

            .tribePolaroidHero .tribePolaroidHero__mobileCard:nth-child(3n) {

              translate: 0 4px;

            }

            .tribePolaroidHero__mobileCard:is(.tribePolaroid--third, .tribePolaroid--fourth) {

              display: block;

            }

            .tribePolaroidHero__mobileCard .tribePolaroid__image {

              aspect-ratio: 1 / 1;

            }

            .tribePolaroidHero__mobileCard .tribePolaroid__caption {

              min-height: 45px;

              padding: 8px 1px 10px;

              font-size: 15px;

              line-height: 1.15;

            }

            .tribePolaroid {

              grid-row: 2;

              width: 100%;

              max-width: 190px;

              padding: 7px 7px 0;

              box-shadow:

                0 2px 3px rgba(35, 30, 20, 0.05),

                0 8px 18px rgba(35, 30, 20, 0.09);

            }

            .tribePolaroid--left {

              grid-column: 1;

              justify-self: end;

              z-index: 1;

              transform: translateX(4px) rotate(-7deg);

            }

            .tribePolaroid--right {

              grid-column: 2;

              justify-self: start;

              z-index: 2;

              transform: translate(-4px, 14px) rotate(6deg);

            }

            .tribePolaroid__image {

              aspect-ratio: 1 / 1;

            }

            .tribePolaroid__caption {

              min-height: 45px;

              padding: 8px 1px 10px;

              font-size: clamp(14px, 3.8vw, 18px);

              line-height: 1.15;

            }

            .tribePolaroidHero__pause {

              right: 12px;

              bottom: 8px;

              width: 30px;

              height: 30px;

            }

          }

          /* A small, upper-right accent; never adds a grid row. */

          .tribePolaroid--third,

          .tribePolaroid--fourth {

            display: none;

          }

          @media (min-width: 441px) {

            .tribePolaroidHero__layout {

              position: relative;

            }

            .tribePolaroid--third {

              display: block;

              position: absolute;

              grid-area: 1 / 3;

              right: -8%;

              bottom: calc(50% + 75px);

              width: 72%;

              max-width: 156px;

              padding: 8px 8px 0;

              z-index: 1;

              transform: rotate(-8deg);

            }

            .tribePolaroid--third .tribePolaroid__caption {

              min-height: 48px;

              padding: 8px 1px 10px;

              font-size: 15px;

              overflow-wrap: anywhere;

            }

          }

          @media (min-width: 1001px) {

            .tribePolaroid--fourth {

              display: block;

              position: absolute;

              left: -7%;

              bottom: calc(50% - 145px);

              width: 72%;

              max-width: 156px;

              padding: 8px 8px 0;

              z-index: 1;

              transform: rotate(7deg);

            }

            .tribePolaroid--fourth .tribePolaroid__caption {

              min-height: 48px;

              padding: 8px 1px 10px;

              font-size: 15px;

              overflow-wrap: anywhere;

            }

          }

          /* Stable desktop angle variation, chosen once per page load. */

          @media (min-width: 441px) {

            .tribePolaroidHero .tribePolaroid {

              --photo-angle: var(--refresh-angle, 0deg);

            }

          }

          /* Cosmetic lift: preserve all existing responsive transforms. */

          .tribePolaroidHero .tribePolaroid {

            translate: 0 0;

            rotate: var(--photo-angle, 0deg);

            transform-origin: center;

            transition:

              translate 200ms cubic-bezier(0.2, 0.65, 0.3, 1),

              rotate 200ms cubic-bezier(0.2, 0.65, 0.3, 1),

              box-shadow 200ms ease;

            -webkit-tap-highlight-color: transparent;

          }

          .tribePolaroidHero .tribePolaroid__image {

            -webkit-user-drag: none;

            -webkit-touch-callout: none;

            -webkit-user-select: none;

            user-select: none;

          }

          @media (hover: hover) and (pointer: fine) {

            .tribePolaroidHero .tribePolaroid:hover {

              --polaroid-interaction-y: -5px;

              --polaroid-interaction-scale: 1.01;

              box-shadow:

                0 4px 8px rgba(35, 30, 20, 0.07),

                0 18px 36px rgba(35, 30, 20, 0.13);

            }

            .tribePolaroidHero .tribePolaroid--left:hover,

            .tribePolaroidHero .tribePolaroid--fourth:hover {

              --polaroid-interaction-rotation: 2deg;

            }

            .tribePolaroidHero .tribePolaroid--right:hover,

            .tribePolaroidHero .tribePolaroid--third:hover {

              --polaroid-interaction-rotation: -2deg;

            }

          }

          @media (hover: none) and (pointer: coarse) {

            .tribePolaroidHero .tribePolaroid:active {

              --polaroid-interaction-y: -3px;

              --polaroid-interaction-scale: 1.015;

              box-shadow:

                0 3px 5px rgba(35, 30, 20, 0.06),

                0 12px 24px rgba(35, 30, 20, 0.12);

            }

            .tribePolaroidHero .tribePolaroid--left:active,

            .tribePolaroidHero .tribePolaroid--fourth:active {

              --polaroid-interaction-rotation: 1.5deg;

            }

            .tribePolaroidHero .tribePolaroid--right:active,

            .tribePolaroidHero .tribePolaroid--third:active {

              --polaroid-interaction-rotation: -1.5deg;

            }

          }

          @media (min-width: 1001px) {

            .tribePolaroidHero .tribeActivityIntro {

              font-size: clamp(26.4px, 2.53vw, 35.2px);

            }

            .tribePolaroidHero .tribeActivitySlot {

              width: calc(100% + 64px);

              margin-inline: -32px;

              font-size: clamp(35.8px, 4.59vw, 69.9px);

            }

          }

          @media (prefers-reduced-motion: reduce) {

            .tribePolaroidHero__layout > .tribePolaroid,

            .tribePolaroidHero__layout > .tribePolaroid .tribePolaroid__image,

            .tribePolaroidHero__layout > .tribePolaroid .tribePolaroid__caption {

              animation: none !important;

            }

            .tribePolaroidHero__mobileTrack {

              animation: none;

            }

            .tribePolaroidHero .tribePolaroid {

              transition: none;

            }

            .tribePolaroidHero .tribePolaroid:is(:hover, :active) {

              translate: 0 0;

              rotate: var(--photo-angle, 0deg);

            }

            .tribePolaroidHero__join,

            .tribePolaroidHero .tribeActivityWord {

              transition: none;

            }

            .tribePolaroidHero .tribeActivityWord {

              transform: none;

            }

          }

        `}

      </style>

      <div className="tribePolaroidHero__layout">

        <div className="tribePolaroidHero__content">

          <h1 id="tribe-hero-title" className="tribePolaroidHero__title">

            <span className="tribeActivityIntro">

              Meet new people through

            </span>

            <span className="tribePolaroidHero__srOnly">

              dinner, karaoke, wine, pizza, yoga, picnics, coastal bike rides,

              museum hangs, and coffee crawls.

            </span>

            <RotatingActivity paused={paused} reduceMotion={reduceMotion} />

          </h1>

          <p className="tribePolaroidHero__description">

          An invite-only social club built around curated experiences. Show up to a gathering and leave with friends.

          </p>

          <div className="tribePolaroidHero__actions">

            <a href="/register" className="tribePolaroidHero__join">

              Become a member

              <LuArrowUpRight size={16} aria-hidden="true" />

            </a>

            <button

              type="button"

              className="tribePolaroidHero__howButton"

              onClick={scrollToHowItWorks}

            >

              How it works

            </button>

            <p className="tribePolaroidHero__membershipNote tribePolaroidHero__actionsNote">

              Free to join · Invite-only

            </p>

          </div>

          <button

            type="button"

            className="tribePolaroidHero__howButton tribePolaroidHero__howDesktop"

            onClick={scrollToHowItWorks}

          >

            How it works

          </button>

          <a href="/register" className="tribePolaroidHero__qr">

            <img

              src={JoinTribeQR}

              alt="Scan to join Tribe"

              width={131}

              height={131}

            />

            <strong>Scan to get started</strong>

            <span className="tribePolaroidHero__membershipNote">

              Free to join · Invite-only

            </span>

          </a>

        </div>

        {desktopPolaroids.map((photo) => (

          <figure

            key={photo.className}

            className={`tribePolaroid ${photo.className}`}

            style={{

              "--refresh-angle": `${photo.angleOffset ?? 0}deg`,

              ...photo.motionStyle,

            }}

            onContextMenu={(event) => event.preventDefault()}

          >

            <img

              className="tribePolaroid__image"

              src={photo.src}

              alt=""

              draggable={false}

              loading="eager"

              decoding="async"

            />

            <figcaption className="tribePolaroid__caption">

              {photo.caption}

            </figcaption>

          </figure>

        ))}

        <div

          className="tribePolaroidHero__mobileMarquee"

          role="region"

          aria-label="Photos from Tribe gatherings"

        >

          <div className="tribePolaroidHero__mobileTrack">

            {[0, 1].map((copyIndex) => (

              <div

                key={`mobile-set-${copyIndex}`}

                className="tribePolaroidHero__mobileSet"

                aria-hidden={copyIndex === 1 ? "true" : undefined}

              >

                {polaroids.slice(0, 4).map((photo, photoIndex) => (

                  <figure

                    key={photo.src}

                    className={`tribePolaroid tribePolaroidHero__mobileCard ${photo.className}`}

                    style={{

                      "--refresh-angle": `${photo.angleOffset ?? 0}deg`,

                      "--mobile-angle": ["-7deg", "5deg", "-4deg", "3deg"][photoIndex % 4],

                    }}

                    onContextMenu={(event) => event.preventDefault()}

                  >

                    <img

                      className="tribePolaroid__image"

                      src={photo.src}

                      alt=""

                      draggable={false}

                      loading="eager"

                      decoding="async"

                    />

                    <figcaption className="tribePolaroid__caption">

                      {photo.caption}

                    </figcaption>

                  </figure>

                ))}

              </div>

            ))}

          </div>

        </div>

      </div>

      {!reduceMotion && (

        <button

          type="button"

          className="tribePolaroidHero__pause"

          aria-label={

            paused ? "Play animations" : "Pause animations"

          }

          onClick={() => setPaused((current) => !current)}

        >

          {paused ? (

            <LuPlay size={13} aria-hidden="true" />

          ) : (

            <LuPause size={13} aria-hidden="true" />

          )}

        </button>

      )}

    </section>

  );

}
